/* eslint-disable react/no-danger */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AWS from 'aws-sdk';
import { Grid } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import Cloudy from '../../../images/Partly-Cloudy.png';
import styles from './weather.module.scss';
import { saveWeatherData } from '../../AirfieldsConditions/components/redux/actions';
import Spinner from '../../../components/spinner';

const Weather = ({ profile, actionSaveWeather, weather }) => {
  const [loading, setLoading] = useState(false);
  const [noWeatherData, setNoWeatherData] = useState(false);
  const [timeDiff, setTimeDiff] = useState(0);

  const getData = () => {
    const today = moment().utc();
    const year = today.year();
    const month = today.month();
    const date = today.date();
    const hour = today.hour();
    const docClient = new AWS.DynamoDB.DocumentClient();
    const params = {
      TableName: `${process.env.REACT_APP_MAIN_PREFIX}weather`,
      Key: { id: `${profile.portal_airport.code.toUpperCase()}_${year}_${month+1}_${date}_${hour-timeDiff}` }
    };
    docClient.get(params).promise().then((data) => {
      if (!data.Item) {
        const diff = timeDiff + 1;
        setLoading(false);
        setTimeDiff(diff);
        if (timeDiff === 4) {
          setNoWeatherData(true);
        }
      } else {
        setTimeDiff(5);
        actionSaveWeather(data.Item.metar);
        setLoading(false);
        setNoWeatherData(false);
      }
    }).catch((err) => {
      setLoading(false);
      console.log(err);
    });
  };

  useEffect(() => {
    if (!weather.summary && timeDiff !== 5) {
      setLoading(true);
      getData();
    }
  }, [weather.summary, timeDiff]);

  const Metrics = profile?.portal_airport?.airport_settings?.metrics;
  const dispTemp = (temp) => {
    const indexValue = temp.indexOf('(');
    if (indexValue !== -1) {
      if (typeof Metrics === 'object') {
        if (Array.isArray(Metrics)) {
          if (Metrics[0]?.metric === 'USCS') {
            return temp.slice(indexValue+1, temp?.length-1);
          }
            return temp.slice(0, indexValue-1);
        }
        if (Metrics?.metric === 'USCS') {
          return temp.slice(indexValue+1, temp?.length-1);
        }
          return temp.slice(0, indexValue-1);
      }
    }
    return temp.slice(0, 6);
  };

  return (
    <div className={`${styles.weather} ${styles.weatherOverFlow}`}>
      <div className={styles.spinner}>
        <Spinner large active={loading} />
      </div>
        <div>
        <div className={styles.top}>
          <img src={Cloudy} alt="" />
          <h3>{ weather && weather.temperature && dispTemp(weather.temperature)}</h3>
        </div>
        <h5>{ weather && weather.summary && weather.summary.toUpperCase()}</h5>
        <div className={styles.navigation}>
          <div className={styles.currentWeatherHeading}>
            <FormattedMessage id="weather.current" defaultMessage="Current Weather" />
          </div>
        </div>
        </div>
        { !noWeatherData
          ? (
            <Grid divided="vertically" className={styles.dataCollection}>
              <Grid.Row className={styles.Collection} columns={2}>
                <Grid.Column className={styles.weatherColumn}>
                  <div className={styles.data}>
                    <span className={`${styles.head} ${styles.label}`}>Relative Humidity</span>
                    <span dangerouslySetInnerHTML={{ __html: weather && weather.humidity }} />
                  </div>
                </Grid.Column>
                <Grid.Column className={styles.weatherColumn}>
                  <div className={styles.data}>
                    <span className={`${styles.head} ${styles.label}`}>Wind</span>
                    <span dangerouslySetInnerHTML={{ __html: weather && weather.wind }} />
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className={styles.Collection} columns={2}>
                <Grid.Column className={styles.weatherColumn}>
                  <div className={styles.data}>
                    <span className={`${styles.head} ${styles.label}`}>Pressure</span>
                    <span dangerouslySetInnerHTML={{ __html: weather && weather.pressure }} />
                  </div>
                </Grid.Column>
                <Grid.Column className={styles.weatherColumn}>
                  <div className={styles.data}>
                    <span className={`${styles.head} ${styles.label}`}>Dewpoint</span>
                    <span dangerouslySetInnerHTML={{ __html: weather && weather.dewpoint }} />
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row className={styles.Collection} columns={1}>
                <Grid.Column className={styles.weatherFullColumn}>
                  <div className={styles.data}>
                    <span className={`${styles.head} ${styles.label}`}>Visibility</span>
                    <span dangerouslySetInnerHTML={{ __html: weather && weather.visibility }} />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          )
          : <div className={styles.noWeatherInfo}> Currently, there is no weather information for the airport</div>}
    </div>
  );
};

const mapStateToProps = state => ({
  weather: state.airfields.weather,
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionSaveWeather: (data) => {
    dispatch(saveWeatherData(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Weather);
